import axios from 'axios';
import apiClient from '../../../services/api';

export type AgriculturalLandCheckResult = {
  is_agricultural: boolean;
  agricultural_fraction: number;
  dynamic_world_crops_fraction?: number;
  worldcover_cropland_fraction?: number;
  rice_fraction: number;
  threshold: number;
  source: string;
  message?: string | null;
};

function geometryPayload(geoJson: any): Record<string, unknown> | null {
  if (!geoJson) return null;
  if (geoJson.type === 'Feature' || geoJson.type === 'FeatureCollection') {
    return geoJson;
  }
  if (geoJson.type === 'Polygon' || geoJson.type === 'MultiPolygon') {
    return geoJson;
  }
  if (geoJson.geometry) {
    return geoJson.geometry;
  }
  return null;
}

/**
 * Soft-fail draw-time check: returns null if the API is unavailable.
 */
export async function checkAgriculturalLand(
  geoJson: any
): Promise<AgriculturalLandCheckResult | null> {
  const geometry = geometryPayload(geoJson);
  if (!geometry) return null;

  try {
    const res = await apiClient.post<AgriculturalLandCheckResult>(
      '/check-agricultural-land/',
      { geometry },
      { timeout: 45000 }
    );
    return res.data ?? null;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      console.warn(
        'Agricultural land check failed:',
        e.response?.status || e.message
      );
    } else {
      console.warn('Agricultural land check failed:', e);
    }
    return null;
  }
}
